import './account-entries'
import buildDatepicker from '@app/adapters/datepicker'
import formSubmit from '@app/adapters/form-submit'
import { onDocumentEvent } from '@app/utils/domHelpers'
import './exact_online_account_selector'
import setupFirmCreation from './setup-firm-creation'
import setupLedgers from './setup-ledgers'
import './market'
import './billing_proposal'
import './special-actions'
import './toggle_selector_visibility'
import './firm_default_permanent_categories'

setupFirmCreation({ onDomLoad })

setupLedgers({
  buildDatepicker,
  formSubmit,
  onDomLoad,
  onDocumentEvent,
})
